/* eslint-disable import/prefer-default-export */
import { UPC_VALIDATION_MESSAGES } from '@modules/upc';

/**
 * * Gift card amount validator
 * @param {string|null} [value]
 */
export const giftCardAmount = (value) => {
  if (value === null || value === undefined || value === '') {
    return UPC_VALIDATION_MESSAGES.VALUE_NOT_SELECTED;
  }
  return true;
};
